import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { BRAND_ASSETS } from '../../config/assets';
import './Footer.css';

export default function Footer() {
      const { pathFor, t } = useLanguage();
      
      return (
            <footer className="footer">
                  <div className="footer__inner">
                        <div className="footer__brand">
                              <img src={BRAND_ASSETS.logo} alt="AgroLlama" className="footer__logo" />
                              <span className="footer__brand-name">AgroLlama</span>
                              <p className="footer__tagline">{t('footer.tagline')}</p>
                        </div>

                        <div className="footer__bank-info">
                              <p className="footer__bank-text"><strong>{t('footer.companyName')}</strong></p>
                              <p className="footer__bank-text">{t('footer.companyNumber')}</p>
                              <p className="footer__bank-text">{t('footer.registeredAddress')}</p>
                        </div>

                        <nav className="footer__nav" aria-label="Footer navigation">
                              <Link to={pathFor('privacy')} className="footer__link">{t('footer.privacyPolicy')}</Link>
                              <span className="footer__sep">|</span>
                              <Link to={pathFor('terms')} className="footer__link">{t('footer.termsOfService')}</Link>
                              <span className="footer__sep">|</span>
                              <Link to={pathFor('support')} className="footer__link">{t('footer.support')}</Link>
                              <span className="footer__sep">|</span>
                              <Link to={pathFor('deletion')} className="footer__link">{t('footer.accountDeletion')}</Link>
                        </nav>

                        <p className="footer__copy">{t('footer.copyright')}</p>
                  </div>
            </footer>
      );
}
